
<div
	class="flow-input-wrapper"
	:class="{ prefix: prefix }"
	:boxType="boxType"
	:type="type"
	:state="state"
	:prefix="prefix"
	:inline="inline"
>
	<div v-if="prefix" :multiline="multiline" :boxType="boxType" class="flow-input-prefix fc-light">
		{{ prefix }}
	</div>
	<input
		v-if="!multiline"
		ref="input-text"
		v-model="innerValue"
		:data-qa-field="dataQaField"
		:type="innerType"
		v-bind="{ ...$props, ...$attrs, ...nativeProps }"
		class="flow-input-text"
		@blur="handleBlur"
		@click="handleClick"
		@keyup="handleKeyup"
		@keypress="handleKeypress"
		@paste="handlePaste"
		@focus="handleFocus"
		@change="handleChange"
		@input="handleInput"
	/>
	<textarea
		v-if="multiline"
		ref="input-text"
		v-model="innerValue"
		:data-qa-field="dataQaField"
		v-bind="{ ...$props, ...$attrs }"
		class="flow-input-text"
		@blur="handleBlur"
		@click="handleClick"
		@keyup="handleKeyup"
		@keypress="handleKeypress"
		@paste="handlePaste"
		@focus="handleFocus"
		@change="handleChange"
		@input="handleInput"
	/>
	<div class="flow-input-state-icon" :stateText="stateText ? true : false">
		<Icon
			v-if="state === 'success'"
			:state="'success'"
			:size="'small'"
			:effects="false"
			name="i-tick"
			type="filled"
			:tooltip="successTooltip"
		/>
		<Icon
			v-if="state === 'error'"
			:state="'error'"
			:size="'small'"
			:effects="false"
			name="i-info-fill"
			type="filled"
			:tooltip="errorTooltip"
			@click="innerValue = ''"
		/>
		<Icon
			v-if="state === 'validating'"
			:state="'primary'"
			:size="'small'"
			:effects="false"
			name="i-loader"
			:animate="true"
		/>
		<Icon
			v-if="disabled"
			:state="'dark'"
			:size="'small'"
			:effects="false"
			:disabled="true"
			name="i-stop"
			type="outlined"
		/>
		<Icon
			v-if="(type === 'password' || type === 'text') && showPasswordEye"
			:state="showPassword ? 'primary' : 'default'"
			:size="'small'"
			:effects="false"
			name="i-view-fill"
			type="filled"
			@click="showPassword = !showPassword"
		/>
		<span v-if="stateText" class="i-state-text">{{ stateText }}</span>
	</div>
	<div v-if="suffixTag" class="flow-input-suffix-tag">
		<Tag :size="'small'" class="upper-case">
			{{ suffixTag }}
		</Tag>
	</div>
</div>
